module.exports = __webpack_public_path__ + "img/up-cadou-craciun.4cb80ac0.png";